export const BoletoTabs = {
  boleto: {
    id: 0,
    href: 'boleto',
    label: 'Boleto',
    navigate: true,
    t: '',
  },
  'denuncias-e-fraudes': {
    id: 1,
    href: 'denuncias-e-fraudes',
    label: 'Dicas de segurança',
    navigate: true,
    t: '',
  },
};
